<template>
  <div class="hello">
    <div class="tab1">
      <div class="tab1-left">
        服务电话：<span style="color: #c7171e">{{ fwmobile }}</span>
      </div>
      <div class="tab1-right">
        <div class="pointer">进入测试平台</div>
        <div class="pointer" @click="page('My')">个人中心</div>
        <div class="pointer" @click="page('Login')">登录/注册</div>
      </div>
    </div>
    <!--  -->
    <div class="tab2">
      <div class="tab2-con">
        <div class="tab2-img pointer" @click="page('Home')">
          <img src="../assets/image/logo.png" alt="" />
        </div>
        <div class="tab2-text">{{ keys }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  name: "HelloWorld",
  props: ["keys"],
  data() {
    return {
      fwmobile: "",
    };
  },
  mounted() {
    this.$apis.getcommoninfo().then((res) => {
      this.fwmobile = res.data.contactinformation[0];
    });
  },
  methods: {
    page(e) {
      if (e == "My" && !localStorage.getItem("token")) {
        Dialog.alert({
          message: "您未登录，请登录",
        }).then(() => {
          // on close
        });
      } else {
        this.$router.push({
          name: e,
          query: {
            id: 1,
          },
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped='scoped'>
.login {
  background-color: #f5f5f5;
  overflow-x: hidden;
}
img {
  width: 100%;
  height: 100%;
}
h2 {
  font-size: 18px;
  color: #000;
}
/* 顶部 */
.tab1 {
  width: 1136px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  padding: 9px;
}
.tab1-right {
  display: flex;
}
.tab1-right div {
  margin-left: 24px;
}
/* 顶部红色导航 */
.tab2 {
  background-color: #c7171e;
}
.tab2-con {
  width: 1136px;
  margin: 0 auto;
  padding: 10px;
  display: flex;
  align-items: center;
}
.tab2-text {
  font-size: 30px;
  color: #fff;
  margin-left: 48px;
  font-size: bold;
  margin-top: 11px;
}
.tab2-img {
  width: 165px;
  height: 95px;
}
.option {
  color: #c7171e;
}
@media screen and (min-width: 991px) and (max-width: 1160px) {
  .tab1 {
    width: 100%;
  }
  .tab2 {
    width: 100%;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .footer-a,
  .footer-bot {
    width: 60%;
  }
  .tab1 {
    width: 100%;
  }
  .tab2 {
    width: 100%;
  }
}
@media only screen and (max-width: 767px) {
  .tab1 {
    display: none;
  }
  .tab2-text {
    font-size: 20px;
    margin-left: 27px;
  }
  .tab2-con {
    width: 90%;
  }
}
</style>
